import React from 'react';
import './CardActions.scss';

interface Props {
  children: React.ReactNode;
}

const CardActions: React.FC<Props> = ({ children }) => {
  return <div className="ui-kit-card-actions">{children}</div>;
};

export default CardActions;
